import { render, staticRenderFns } from "./PPBom.vue?vue&type=template&id=2aa8c9ac&scoped=true&"
import script from "./PPBom.vue?vue&type=script&lang=js&"
export * from "./PPBom.vue?vue&type=script&lang=js&"
import style0 from "./PPBom.vue?vue&type=style&index=0&id=2aa8c9ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa8c9ac",
  null
  
)

export default component.exports